import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { motion } from 'framer-motion';
import {
    FaReply,
    FaIdCard,
    FaSignOutAlt,
    FaSwimmingPool,
    FaListAlt
} from 'react-icons/fa';
import { BiIdCard } from "react-icons/bi";
import { GiArchiveRegister } from "react-icons/gi";
import { MdPeople } from "react-icons/md";
import './MenuPage.css';
import { logout } from '../../reduser/userSlice';

function MenuPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const permissions = useSelector(state => state.user.permissions || []);


    const menuItems = [
        {
            id: 6,
            title: 'Бассейн',
            icon: <FaSwimmingPool size={24} />,
            path: '/note/pool_booking',
            description: 'Бронирование бассейна',
            color: '#00bcd4'
        },
        {
            id: 7,
            title: 'Мои занятия',
            icon: <FaListAlt size={24} />,
            path: '/note/pool_active',
            description: 'Активные занятия в бассейне',
            color: '#0097a7'
        }
    ];

    const supervisorItems = [
        {
            id: 5,
            title: 'Активация',
            icon: <MdPeople size={24} />,
            path: '/activate_user',
            description: 'Активация новых пользователей',
            color: '#E91E63'
        }, {
            id: 1,
            title: 'Замещение',
            icon: <FaReply size={24} />,
            path: '/note/substitution',
            description: 'Создать новое замещение',
            color: '#4CAF50'
        },
        // {
        //     id: 2,
        //     title: 'Архив замещения',
        //     icon: <GiArchiveRegister size={24} />,
        //     path: '/note/substitution_archive',
        //     description: 'Просмотр архива замещений',
        //     color: '#2196F3'
        // },
        {
            id: 3,
            title: 'Пропуска сотрудникам',
            icon: <BiIdCard size={24} />,
            path: '/note/new_pass',
            description: 'Новая заявка на пропуск',
            color: '#FF9800'
        },
        {
            id: 4,
            title: 'Архив пропусков',
            icon: <FaIdCard size={24} />,
            path: '/note/pass_archive',
            description: 'Архив заявок на пропуск',
            color: '#9C27B0'
        },
        {
            id: 9,
            title: 'Пропуска гостям',
            icon: <FaIdCard size={24} />,
            path: '/temporaryPasses',
            description: 'Новая заявка на пропуск',
            color: '#9C27B0'
        },
        {
            id: 10,
            title: 'Согласование пропусков',
            icon: <FaIdCard size={24} />,
            path: '/temporaryPassesList',
            description: 'Согласование пропусков гостям',
            color: '#9C27B0'
        },
    ];

    const systemItems = [
        {
            id: 8,
            title: 'Выход',
            icon: <FaSignOutAlt size={24} />,
            path: '/logout',
            description: 'Выйти из системы',
            color: '#F44336',
            isLogout: true
        }
    ];

    const filteredSupervisorItems = supervisorItems.filter(item => {
        if (item.title) {
            return permissions.some(p => p.name === item.title);
        }
        return true;
    });


    const handleNavigation = (item) => {
        if (item.isLogout) {
            dispatch(logout());
            navigate('/login');
        } else {
            navigate(item.path);
        }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.04
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 250
            }
        }
    };

    return (
        <Container fluid className="menu-container">
            {/* Заголовок */}

            {/* Основные пункты меню */}
            <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                className="menu-grid"
            >
                {filteredSupervisorItems.length > 0 && (
                    <>
                        <h2 className="section-title">Разделы для руководителей</h2>
                        <Row>
                            {filteredSupervisorItems.map((item) => (
                                <Col xs={6} md={4} lg={3} key={item.id} className="mb-4">
                                    <motion.div variants={itemVariants}>
                                        <Card
                                            className="menu-card"
                                            onClick={() => handleNavigation(item)}
                                            style={{
                                                borderLeft: `4px solid ${item.color}`,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <Card.Body className="menu-card-body">
                                                <div
                                                    className="menu-icon-wrapper"
                                                    style={{ color: item.color }}
                                                >
                                                    {item.icon}
                                                </div>
                                                <Card.Title className="menu-card-title">
                                                    {item.title}
                                                </Card.Title>
                                                <Card.Text className="menu-card-description">
                                                    {item.description}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </motion.div>
                                </Col>
                            ))}
                        </Row>
                    </>
                )}
                <h2 className="section-title">Разделы для сотрудников</h2>
                <Row>
                    {menuItems.map((item) => (
                        <Col xs={6} md={4} lg={3} key={item.id} className="mb-4">
                            <motion.div variants={itemVariants}>
                                <Card
                                    className="menu-card"
                                    onClick={() => handleNavigation(item)}
                                    style={{
                                        borderLeft: `4px solid ${item.color}`,
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Card.Body className="menu-card-body">
                                        <div
                                            className="menu-icon-wrapper"
                                            style={{ color: item.color }}
                                        >
                                            {item.icon}
                                        </div>
                                        <Card.Title className="menu-card-title">
                                            {item.title}
                                        </Card.Title>
                                        <Card.Text className="menu-card-description">
                                            {item.description}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    ))}
                </Row>



                {/* Системные настройки */}
                <h2 className="section-title">Система</h2>
                <Row>
                    {systemItems.map((item) => (
                        <Col xs={6} md={4} lg={3} key={item.id} className="mb-4">
                            <motion.div variants={itemVariants}>
                                <Card
                                    className={`menu-card ${item.isLogout ? 'logout-card' : ''}`}
                                    onClick={() => handleNavigation(item)}
                                    style={{
                                        borderLeft: `4px solid ${item.color}`,
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Card.Body className="text-center">
                                        <div
                                            className="menu-icon"
                                            style={{ color: item.color }}
                                        >
                                            {item.icon}
                                        </div>
                                        <Card.Title className="menu-card-title">
                                            {item.title}
                                        </Card.Title>
                                        <Card.Text className="menu-card-description">
                                            {item.description}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    ))}
                </Row>
            </motion.div>

        </Container>
    );
}

export default MenuPage;